import React from "react";
import { format } from "date-fns";
import { ICellRendererParams } from "@ag-grid-community/core";

import { PickupRequestListItem } from "../../../../types";

import TwoLineGridCell from "../TwoLineGridCell";

interface Props extends ICellRendererParams {
  data: PickupRequestListItem;
}

const SubmittedDateGridCell = (props: Props) => {
  const date = new Date(props.data.submittedDate || Date.now());

  return (
    <TwoLineGridCell
      firstLineData={format(date, "MMM d, yyyy")}
      secondLineData={format(date, "h:mm a")}
    />
  );
};

export default SubmittedDateGridCell;
